import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem } from '@mui/material';

const LangSelect = forwardRef(({ emptyLabel, translatedInCurrentLanguage = false, short = false, ...params }, ref) => {
    const { t, i18n } = useTranslation();

    return (
        <Select ref={ref} {...params} >
            {emptyLabel && <MenuItem value="">{emptyLabel}</MenuItem>}
            {Object.keys(i18n.services.resourceStore.data).map((lng) => (
                <MenuItem key={lng} value={lng}>
                    {short ? lng :
                        translatedInCurrentLanguage ? t('lang.' + lng)
                            : t("languageName", { lng })}
                </MenuItem>
            ))}
        </Select>
    );
});

export default LangSelect;